export default __webpack_public_path__ + "static/media/icon-chat-decline.35ab19ff.svg";